import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { Grid } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";

export default function DropzoneCommentImage(props: any) {
  const [files, setFiles] = useState([]);

  const onDrop = useCallback((acceptedFiles: any) => {
    setFiles(
      acceptedFiles.map((file: Blob | MediaSource) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  }, []);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpeg": [],
      "image/png": [],
      // "application/pdf": [],
      // "application/x-zip-compressed": [],
      // "application/x-rar-compressed": [".zip", ".rar", ".7zip"],
    },
    onDrop: onDrop,
    noClick: props.errors,
  });

  useEffect(() => {
    if (files.length > 0) {
      props.onFileChoosed(acceptedFiles);
    }
  }, [files]);
  return (
    <>
      <Grid
        container
        direction={"column"}
        gap={"0.5rem"}
        {...getRootProps({ className: "dropzone" })}
      >
        <input {...getInputProps()} ref={props.refDropZone} />

        <Grid
          item
          sx={{
            borderRadius: "50%",
            background: "#01af43",
            height: "48px",
            width: "48px",
            padding: "1rem",
          }}
        >
          <ImageOutlinedIcon
            sx={{ color: "#fff", width: "100%", height: "100%" }}
          />
        </Grid>
        <Grid item sx={{ color: "#fff" }}>
          ارسال عکس
        </Grid>
      </Grid>
    </>
  );
}
